export function makeId(name: string) {
    return `leat-${name}`;
}